import classNames from "classnames";
import styles from "./Input.module.scss";
import type { InputFontSize, InputSize, InputVariant } from "./Input.types";

const variantClassNames: Record<InputVariant, string> = {
    primary: styles.primary,
    ghost: styles.ghost,
    accent: styles.accent,
};

const sizeClassNames: Record<InputSize, string> = {
    md: styles.md,
    lg: styles.lg,
    xl: styles.xl,
};

/**
 * Root class list shared by InputRoot and the composed Input, so the
 * discriminated prop unions are checked once at the call site and both
 * components paint identical chrome from widened values.
 */
export const getInputRootClassName = ({
    variant,
    size,
    fontSize,
    className,
}: {
    variant: InputVariant;
    size: InputSize;
    fontSize: InputFontSize;
    className?: string;
}) =>
    classNames(
        styles.root,
        variantClassNames[variant],
        sizeClassNames[size],
        fontSize === 12 && styles.textXs,
        className,
    );
